import { Component, OnInit, ViewChild } from '@angular/core';
import {
  BinanceDepositService,
  BinanceDeposit,
  QueryBinanceDepositDto,
} from '../../services/binance-deposit.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import {
  AsignarDepositoDialogComponent,
  AsignarDepositoDialogData,
  puedeAsignarDeposito,
} from './asignar-deposito-dialog/asignar-deposito-dialog.component';

@Component({
  selector: 'app-list-pays-wallets-operator',
  templateUrl: './list-pays-wallets-operator.component.html',
  styleUrls: ['./list-pays-wallets-operator.component.sass'],
})
export class ListPaysWalletsOperatorComponent implements OnInit {
  displayedColumns: string[] = [
    'txId',
    'userId',
    'coin',
    'network',
    'amount',
    'address',
    'binanceStatus',
    'internalStatus',
    'abonada',
    'insertTime',
    'completeTime',
    'acciones',
  ];
  dataSource = new MatTableDataSource<BinanceDeposit>([]);
  total = 0;
  pageSize = 10;
  pageIndex = 0;
  loading = false;
  errorMsg = '';

  filters: QueryBinanceDepositDto = {};

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private depositService: BinanceDepositService,
    private dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.getDeposits();
  }

  getDeposits(event?: PageEvent) {
    this.loading = true;
    if (event) {
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
    }
    const query: QueryBinanceDepositDto = {
      ...this.filters,
      offset: this.pageIndex * this.pageSize,
      limit: this.pageSize,
    };
    this.depositService.findAll(query).subscribe({
      next: (res) => {
        this.dataSource.data = res.items;
        this.total = res.total;
        this.loading = false;
        this.errorMsg = '';
      },
      error: (err) => {
        this.loading = false;
        this.errorMsg = err.message || 'Error al cargar transacciones';
      },
    });
  }

  applyFilters() {
    this.pageIndex = 0;
    this.getDeposits();
  }

  /** La fila admite «Asignar a cliente» (sin dueño, sin abonar, SUCCESS). */
  puedeAsignar(dep: BinanceDeposit): boolean {
    return puedeAsignarDeposito(dep);
  }

  /**
   * «Asignar a cliente» (25/10/2026): lo que el cliente no puede reclamar solo
   * (más de 30.000 USDT o más de 72 h) lo asigna un operador desde acá. Al
   * cerrar con éxito (o con resultado incierto) se refresca la lista.
   */
  asignar(dep: BinanceDeposit) {
    if (!this.puedeAsignar(dep)) return;
    const ref = this.dialog.open<
      AsignarDepositoDialogComponent,
      AsignarDepositoDialogData,
      boolean
    >(AsignarDepositoDialogComponent, {
      data: { deposito: dep },
      width: '560px',
      maxWidth: 'calc(100vw - 32px)',
      maxHeight: '90vh',
      autoFocus: false,
      // Solo se cierra con Cancelar/X (`cerrar()`), que refresca si hace falta.
      disableClose: true,
    });
    ref.afterClosed().subscribe((refrescar) => {
      if (refrescar) this.getDeposits();
    });
  }
}
